<template>
    <div id="magic-zoom">
        <div itemscope itemtype="http://schema.org/Thing">
            <div class="ItemImgWrap justify-content-center" :class="{'more-images': magiczoom.images.all.length > 1 }">
            <!-- TODO: Magiczoom multiligual -->
            <a :href="magiczoom.images | itemImages('url') | itemImage" id="ItemImgZoom"  aria-label="image zoom" class="MagicZoomPlus flex-fill d-flex align-items-start justify-content-center"
               :data-mobile-options="'zoomMode:off; lazyZoom: true; textTouchZoomHint:'+  $translate('Servershop5::Template.singleZoomHint') +'; textClickZoomHint: '+ $translate('Servershop5::Template.singleZoomHint2') +'; textExpandHint: '+$translate('Servershop5::Template.singleZoomHint')"
               :data-options="
               'zoomMode: off; zoomOn: click; lazyZoom: true; textClickZoomHint: Klicken um zu vergrößern; ' +
                'cssClass: white-bg; ;'+'textExpandHint:'+ $translate('Servershop5::Template.singleZoomHint3')+'; zoomPosition: #zoom-placeholder;'
                ">
                <img  alt="middle size zoom image" class="img-fluid" :src="magiczoom.images | itemImages('urlMiddle') | itemImage" itemprop="image">
            </a>
            </div>
            <div class="text-muted small ml-5 mb-2">{{ $translate('Servershop5::Template.deliveryScopeHint') }}</div>
            <template v-if="magiczoom.images.all.length > 1">
                <div class="magic-more-images position-relative d-flex mb-4" v-if="magiczoom.images.all.length > 3">
                    <div @click="slidePrev()" class="arrows left">
                        <i class="fa fa-angle-left"></i>
                    </div>
                   <hooper class="d-block flex-fill" :settings="hoopersettings" ref="carousel">
                       <slide v-for="(imagePreview, index) in magiczoom.images.all">
                           <a :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].urlMiddle" class="border">
                               <img
                                   :alt="'preview image zoom'+index"
                                       class="img-fluid"
                                       :data-src="imagePreview.url"
                                       :src="imagePreview.urlPreview">
                           </a>
                       </slide>
                   </hooper>
                    <div @click="slideNext" class="arrows right">
                        <i class="fa fa-angle-right"></i>
                    </div>
                </div>
                <div class="magic-more-images d-none d-lg-flex mb-4" v-else>
                   <template v-for="(imagePreview, index) in magiczoom.images.all">
                       <a :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].urlMiddle" class="mb-2 border maxWidthImages">
                           <img
                               :alt="'preview image zoom'+index"
                                   class="img-fluid"
                                   :data-src="imagePreview.url"
                                   :src="imagePreview.urlPreview">
                       </a>
                   </template>
                </div>
            </template>
            <div class="zoom-navigation-dots d-md-none">
            </div>
        </div>
    </div>
</template>

<script>
    import { Hooper, Slide  } from 'hooper';
    export default
    {
        components: { Hooper, Slide },
        props:
            {
                template:
                    {
                        type: String,
                        default: "#vue-magic-zoom"
                    }
            },
        inject:
            {
                itemId:
                    {
                        default: null
                    }
            },
        data: function()
        {
            return {
                onloadVarId: this.currentVariation().variation.id,
                dotsCount: 0,
                hoopersettings:
                {
                    centerMode:true,
                    trimWhiteSpace:true,
                    infiniteScroll:false,
                    itemsToShow: 3,
                    breakpoints:
                    {
                        1000: {
                            itemsToShow: 2
                        },
                        1200: {
                            itemsToShow: 3
                        },
                        1600: {
                            itemsToShow: 4
                        },
                        1800: {
                            itemsToShow: 5
                        }
                    }
                }
            }
        },
        methods:
            {
                currentVariation: function()
                {
                  return this.$store.getters[`${this.itemId}/currentItemVariation`];
                },
                getDots: function()
                {
                    this.dotsCount =   this.currentVariation().images.all.length
                },
                slideNext() {
                    this.$refs.carousel.slideNext();
                },
                slidePrev() {
                    this.$refs.carousel.slidePrev();
                },
            },
        computed:
            {

                magiczoom: function()
                {
                    this.getDots();
                    return this.currentVariation();
                }
            }
    }
</script>
